/* eslint-disable default-param-last */
import merge from 'deepmerge';
import { HYDRATE } from 'next-redux-wrapper';

export const ACTIONS = {
  GET_PUBLIC_INFO: 'PUBLIC/GET_PUBLIC_INFO',
  SET_PUBLIC_INFO: 'PUBLIC/SET_PUBLIC_INFO',
};

export const initialState = {
  publicInfo: null,
};

const PUBLIC_REDUCER = (state = initialState, action) => {
  switch (action.type) {
    case HYDRATE: {
      const { public: publicInfo } = action.payload;
      /* neceisto preservar lo que viene del sever excepto los filtros */
      const nextState = merge(state, publicInfo);
      return nextState;
    }
    case ACTIONS.GET_PUBLIC_INFO:
      return {
        ...state,
        publicInfoState: 'FETCHING',
        id: action.payload,
      };
    case ACTIONS.SET_PUBLIC_INFO: {
      const { status, data } = action.payload;
      return {
        ...state,
        publicInfoState: status,
        publicInfo: data,
      };
    }
    default:
      return { ...state };
  }
};

export const actions = {
  getpublicInfo: (alias, build = false) => ({
    type: ACTIONS.GET_PUBLIC_INFO,
    payload: { alias, build },
  }),
  setpublicInfo: (data) => ({
    type: ACTIONS.SET_PUBLIC_INFO,
    payload: data,
  }),
};

export default PUBLIC_REDUCER;
